<template>
  <div>
    <header ref="topNavbar" class="top-navbar" :class="{ 'top-navbar__authenticated': isSidebarVisible }">
      <div class="top-navbar__container">
        <RouterLink to="/" class="brand">
          <img src="@/assets/logo.png" alt="m2VET">
        </RouterLink>

        <nav v-if="!isSidebarVisible" class="top-navbar__menu">
          <RouterLink to="/">Strona główna</RouterLink>
          <RouterLink to="/announcements">Ogłoszenia</RouterLink>
          <RouterLink to="/blog">Blog</RouterLink>
<!--          <a href="http://warsztaty.m2vet.pl" target="_blank" rel="noopener noreferrer">Szkolenia</a>-->
        </nav>

        <div class="top-navbar__actions">
          <RouterLink to="/login" class="login-link">
            {{ currentUser ? 'Konto' : 'Zaloguj się' }}
            <span>{{ currentUser ? currentUserData.name : null }}</span>
          </RouterLink>
          <RouterLink to="/register" v-if="! currentUser" class="register-link">Zarejestruj się</RouterLink>

          <ButtonVue
            class="top-navbar__btn"
            v-if="isBiz && !isSidebarVisible"
            :text="isBiz=='true' ? 'Dla Usługobiorcy' : 'Dla Biznesu'"
            bgColor="#f97316"
            color="#fff"
            @click="() => {
            $emit('toggleBlur')
            appStore.setIsBusiness(isBiz)
            }"
          />

          <ButtonVue
              v-if="isSidebarVisible"
              text="Wyloguj"
              bgColor="#f97316"
              color="#fff"
              @click="logOut"
          />

          <button
              v-if="isSidebarVisible"
              class="sidebar-toggle"
              type="button"
              @click="isSidebarOpen = !isSidebarOpen"
          >
            Menu
          </button>
        </div>
      </div>
    </header>

    <div
        v-if="isSidebarVisible"
        class="sidebar-overlay"
        :class="{ 'is-open': isSidebarOpen }"
        @click="isSidebarOpen = false"
    ></div>

    <aside class="sidebar" v-if="isSidebarVisible" :class="{ 'is-open': isSidebarOpen }">
      <div class="profile-nav-container" v-if="currentLocation().split('/')[1] == 'profile'">
        <RouterLink to="/profile/user-data">Twoje dane</RouterLink>
        <RouterLink to="/profile/visits">Wizyty</RouterLink>
        <RouterLink to="/profile/recommendations">Zalecenia</RouterLink>
        <RouterLink to="/profile/messages">Wiadomości</RouterLink>
        <RouterLink to="/profile/fav-services">Ulubione usługi</RouterLink>
        <RouterLink to="/profile/announcements">Moje ogłoszenia</RouterLink>
        <RouterLink to="/profile/report-error">Zgłoś błąd <img src="@/assets/icons/question-mark.svg" alt=""></RouterLink>
      </div>
      <div class="profile-nav-container" v-if="currentLocation().split('/')[1] == 'admin-profile'">
        <RouterLink to="/admin-profile/categories">Specjalizacje</RouterLink>
        <RouterLink to="/admin-profile/contact-info">Dane kontaktowe</RouterLink>
        <RouterLink to="/admin-profile/blog">Blog</RouterLink>
        <RouterLink to="/admin-profile/footer">Stopka</RouterLink>
        <RouterLink to="/admin-profile/partners">Partnerzy</RouterLink>
        <RouterLink to="/admin-profile/mailbox">Wiadomości</RouterLink>
        <RouterLink to="/admin-profile/regulations">Regulaminy</RouterLink>
        <RouterLink to="/admin-profile/service-verify">Weryfikowanie usług</RouterLink>
        <RouterLink to="/admin-profile/users">Użytkownicy</RouterLink>
        <RouterLink to="/admin-profile/users/download">Użytkownicy CSV</RouterLink>
        <RouterLink to="/admin-profile/price-list">Ceny</RouterLink>
        <RouterLink to="/admin-profile/subscribers">Subskrybenci</RouterLink>
        <RouterLink to="/admin-profile/recommenders">Polecający</RouterLink>
        <RouterLink to="/admin-profile/page-reviews">Oceny serwisu</RouterLink>
        <RouterLink to="/admin-profile/announcements-verify">Weryfikowanie ogłoszeń</RouterLink>
        <RouterLink to="/admin-profile/reports">Zgłoszenia</RouterLink>
        <RouterLink to="/admin-profile/newsletter">Newsletter</RouterLink>
        <RouterLink to="/admin-profile/titles">Tytuły usług</RouterLink>
        <RouterLink to="/admin-profile/stats">Statystyki kliknięć</RouterLink>
        <RouterLink to="/admin-profile/hints">Podpowiedzi</RouterLink>
        <RouterLink to="/admin-profile/change-password">Zmień hasło</RouterLink>
      </div>
      <div class="profile-nav-container" v-if="currentLocation().includes('/dla-biznesu/profile')">
        <RouterLink to="/dla-biznesu/profile/user-data">Twoje dane</RouterLink>
        <RouterLink to="/dla-biznesu/profile/announcements">Ogłoszenia</RouterLink>
        <RouterLink to="/dla-biznesu/profile/subscriptions">Subskrypcje</RouterLink>
        <RouterLink v-if="appStore.isSubscribed" to="/dla-biznesu/profile/services-provided">Świadczone usługi</RouterLink>
        <RouterLink v-if="appStore.isSubscribed" to="/dla-biznesu/profile/messages">Wiadomości</RouterLink>
        <RouterLink to="/dla-biznesu/profile/employees">Pracownicy</RouterLink>
        <RouterLink v-if="appStore.isSubscribed" to="/dla-biznesu/profile/calendar">Kalendarz</RouterLink>
        <RouterLink v-if="appStore.isSubscribed" to="/dla-biznesu/profile/recommendations">Zalecenia</RouterLink>
        <RouterLink v-if="appStore.isSubscribed" to="/dla-biznesu/profile/useful-tips">Porady <img src="@/assets/icons/bulb.svg" alt=""></RouterLink>
        <RouterLink to="/dla-biznesu/profile/report-error">Zgłoś błąd <img src="@/assets/icons/question-mark.svg" alt=""></RouterLink>
      </div>
      <div class="profile-nav-container" v-if="currentLocation().includes('/dla-biznesu/employee-profile')">
        <RouterLink to="/dla-biznesu/employee-profile/user-data">Twoje dane</RouterLink>
        <RouterLink to="/dla-biznesu/employee-profile/report-error">Zgłoś błąd <img src="@/assets/icons/question-mark.svg" alt=""></RouterLink>
      </div>
      <div class="profile-nav-container" v-if="currentLocation().includes('/firm-profile')">
        <RouterLink to="/firm-profile">Twoje dane</RouterLink>
        <RouterLink to="/firm-profile/specialists">Specjaliści</RouterLink>
        <RouterLink to="/firm-profile/report-error">Zgłoś błąd <img src="@/assets/icons/question-mark.svg" alt=""></RouterLink>
      </div>
    </aside>
  </div>
</template>

<script>
import ButtonVue from './Button.vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
export default{
  name:'NavigationVue',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data(){
    return{
      isSidebarOpen: false,
      resizeObserver: null
    }
  },
  components: {
    ButtonVue
  },
  computed:{
    currentUser() {
      return this.authStore.loggedIn
    },
    currentUserData() {
      return this.authStore.user;
    },
    isPublicRoute() {
      const path = this.$route.path;
      const publicExact = [
        '/404', '/dla-biznesu', '/', '/login', '/login/reset', '/login/reset2',
        '/register', '/blog', '/announcements', '/browser', '/statute',
        '/cookies', '/privacy', '/report', '/spec-browser', '/register2',
        '/confirm-newsletter', '/advance-payment/result', '/profile/make-appointment'
      ];
      return publicExact.includes(path) || path.indexOf('/blog/entry/') === 0 || path.indexOf('/browse/user/') === 0;
    },
    isSidebarVisible() {
      return this.currentUser && !this.isPublicRoute;
    },
    isBiz(){
      if(!useRoute()?.fullPath?.includes('/dla-biznesu') ?? false){
        return 'false'
      }else if(useRoute()?.fullPath?.includes('/dla-biznesu')?? false){
        return 'true'
      }else{
        return false
      }
    }
  },
  watch: {
    '$route.fullPath'() {
      this.isSidebarOpen = false
      this.$nextTick(() => this.updateNavbarHeightVar())
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateNavbarHeightVar()
      if (window.ResizeObserver && this.$refs.topNavbar) {
        this.resizeObserver = new ResizeObserver(() => this.updateNavbarHeightVar())
        this.resizeObserver.observe(this.$refs.topNavbar)
      }
      window.addEventListener('resize', this.updateNavbarHeightVar)
    })
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    window.removeEventListener('resize', this.updateNavbarHeightVar)
  },
  methods:{
    currentLocation(){
      return useRoute().fullPath
    },
    updateNavbarHeightVar() {
      const navbar = this.$refs.topNavbar
      const height = navbar ? navbar.offsetHeight : 80
      document.documentElement.style.setProperty('--navbar-height', `${height}px`)
    },
    async logOut() {
      this.isSidebarOpen = false;
      await this.authStore.logout();
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped lang='scss'>
.router-link-active{
  font-weight: 700;
  color: #10b981;
}
.top-navbar{
  background: #fff;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
  top: 0;
  left: 0;
  right: 0;
  z-index: 60;
  &__authenticated {
    background: #176b4d;
    box-shadow: none;
    position: fixed;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    .top-navbar__container{
      max-width: 100%;
    }
    .top-navbar__menu a,
    .login-link,
    .login-link span{
      color: #fff;
    }
  }
}
.top-navbar__container{
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}
.brand img{
  width: 148px;
}
.top-navbar__menu{
  display: flex;
  align-items: center;
  gap: 28px;
  a{
    text-decoration: none;
    color: #4b5563;
    font-size: 1.65rem;
    font-weight: 700;
    transition: color .2s ease;
  }
  a:hover{
    color: #10b981;
  }
}
.top-navbar__actions{
  display: flex;
  align-items: center;
  gap: 12px;
}
.login-link, .register-link{
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #4b5563;
  font-size: 1.65rem;
  font-weight: 700;
  span{
    font-size: 1.2rem;
    color: #6b7280;
  }
}
.sidebar-toggle{
  display: none;
  border: 1px solid #d1d5db;
  background: #fff;
  border-radius: 10px;
  padding: 8px 12px;
  font-size: 1.4rem;
  cursor: pointer;
}
.sidebar-overlay{
  display: none;
}
.sidebar{
  position: fixed;
  top: var(--navbar-height, 80px);
  left: 0;
  width: 300px;
  height: calc(100vh - var(--navbar-height, 80px));
  overflow-y: auto;
  background: #176b4d;
  padding: 18px 14px;
  z-index: 50;
}
.profile-nav-container{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  a{
    text-decoration: none;
    color: #ffffff;
    font-size: 1.6rem;
    display: flex;
    align-items: center;
    gap: 6px;
  }
}
@media(max-width: 1100px){
  .sidebar-toggle{
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .sidebar-overlay{
    display: block;
    position: fixed;
    top: var(--navbar-height, 80px);
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    opacity: 0;
    pointer-events: none;
    transition: opacity .2s ease;
    z-index: 45;
  }
  .sidebar-overlay.is-open{
    opacity: 1;
    pointer-events: auto;
  }
  .sidebar{
    width: 280px;
    transform: translateX(-100%);
    transition: transform .25s ease;
  }
  .sidebar.is-open{
    transform: translateX(0);
  }
}
@media(max-width: 900px){
  .brand img {
    max-width: 100px;
  }
  .top-navbar__container{
    flex-wrap: wrap;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .top-navbar__menu{
    order: 3;
    width: 100%;
    justify-content: center;
    gap: 16px;
    flex-wrap: wrap;

    a {
      font-size: 1.4rem;
    }
  }
  .top-navbar__btn {
    display: none;
  }
  .login-link, .register-link{
    font-size: 1.4rem;
  }
}
</style>